import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';

interface EditUserModalProps {
  modal?: boolean
  setModal? : any
  patient?: any
  handleSendEmail?: any
}

const SendEmailModal: React.FC<EditUserModalProps> = ({ modal, setModal, patient, handleSendEmail }) => {
  return (
    <div>
      <Modal isOpen={modal} toggle={setModal}>
        <ModalHeader>Send Report</ModalHeader>
        <Form className="theme-form">
          <ModalBody>
            {
              patient && patient?.type === "adult" 
              ? <div>
                {patient?.email} <br />
                <br />
                Would you like to send the generated report to this email?
              </div> 
              : <div>
                <div><span style={{fontWeight: 600}}>Patient:</span> {patient?.email}</div>
                {
                  patient?.teacher_email && <div><span style={{fontWeight: 600}}>Teacher:</span> {patient?.teacher_email}</div>
                }
                {
                  patient?.gp_email && <div><span style={{fontWeight: 600}}>GP:</span> {patient?.gp_email}</div>
                }
                <div className='mt-3' style={{fontSize: '16px'}}>We will send the report to these emails.</div>
              </div>
            }
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleSendEmail}>
              Send
            </Button>{' '}
            <Button color="danger" onClick={() => {
              setModal();
            }}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>

      </Modal>
    </div>
  );
}

export default SendEmailModal;